"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TeamsDocGrid", {
  enumerable: true,
  get: function get() {
    return _TeamsDocGrid.TeamsDocGrid;
  }
});
var _TeamsDocGrid = require("./TeamsDocGrid");